export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT = {
  phone: '0766 330 933',
  phoneHref: 'tel:+40766330933',
  whatsapp: 'https://wa.me/40766330933?text=Bun%C4%83%20ziua!%20A%C8%99%20dori%20o%20ofert%C4%83.',
  email: 'domidoorsolutions@gmail.com',
  address: 'Strada Principală Nr. 1544, Loc. Cenad, Jud. Timiș',
  hours: 'Luni–Vineri · 09:00–17:30',
};

export const ANPC = {
  sal: 'https://anpc.ro/ce-este-sal/',
  sol: 'https://ec.europa.eu/consumers/odr',
};

export const COMPANY = {
  name: 'DOMIDOOR SOLUTIONS S.R.L.',
  address: 'Sat Cenad, Com. Cenad, Nr. 1544, Spatiul 2, Jud. Timiș',
};

export const DEVELOPER = {
  name: 'DIGITAL AGENCY NGR SRL',
  url: 'https://digitalagencyngr.com',
};

// Social profiles for the utility mini-bar (top-right).
export const SOCIAL = {
  facebook: 'https://www.facebook.com/profile.php?id=100063757082683',
  instagram: 'https://www.instagram.com/domidoor.solutions',
  linkedin: '#',
};


export const IMG = {
  hero: 'https://images.unsplash.com/photo-1600047509358-9dc75507daeb?auto=format&fit=crop&w=2000&q=85',
  pvc: 'https://images.unsplash.com/photo-1769726847318-20d64c92672e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHw0fHx3aW5kb3clMjBmcmFtZSUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODU1MDM3NTR8MA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=1400',
  garaj: 'https://images.unsplash.com/photo-1641538926315-265729863fb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxibGFjayUyMG1vZGVybiUyMGdhcmFnZSUyMGRvb3J8ZW58MHx8fHwxNzg1NTAzNzU0fDA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=1400',
  garaj2: 'https://images.unsplash.com/photo-1600047509358-9dc75507daeb?auto=format&fit=crop&w=1400&q=80',
  garaj3: 'https://images.unsplash.com/photo-1605146769289-440113cc3d00?auto=format&fit=crop&w=1400&q=80',
  garaj4: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?auto=format&fit=crop&w=1400&q=80',
  auto: 'https://images.unsplash.com/photo-1645005047809-8a7740441037?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBzbGlkaW5nJTIwZ2F0ZSUyMGhvdXNlfGVufDB8fHx8MTc4NTUwMzc1NHww&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=1400',
  despre: 'https://images.unsplash.com/photo-1505798577917-a65157d3320a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxjcmFmdHNtYW4lMjBpbnN0YWxsaW5nJTIwd2luZG93fGVufDB8fHx8MTc4NTUwMzc1NHww&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=1400',
  house1: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80',
  house2: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1400&q=80',
  house3: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1400&q=80',
  house4: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=1400&q=80',
  interior1: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1400&q=80',
  interior2: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1400&q=80',
  office: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80',
  night: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1400&q=80',
};
